<div class="bulk-upload-results-modal">
  <h2 mat-dialog-title>{{ 'pages.stock.bulkUpload.results.title' | translate }}</h2>

  <mat-dialog-content class="modal-content">

    <div class="summary-section">
      <h3>{{ 'pages.stock.bulkUpload.results.summary' | translate }}</h3>
      
      <ul>
        <li><strong>{{ 'pages.stock.bulkUpload.results.successfulProducts' | translate }}:</strong> {{ response.summary?.successful || 0 }}</li>
        <li *ngIf="getSkippedDueToMissingData() > 0">
          <strong>{{ 'pages.stock.bulkUpload.results.skippedMissingData' | translate }}:</strong> {{ getSkippedDueToMissingData() }}
        </li>
        <li *ngIf="getTotalConsolidationsCount() > 0" class="success-text">
          <strong>{{ 'pages.stock.bulkUpload.results.consolidated' | translate }}:</strong> {{ getTotalConsolidationsCount() }}
        </li>
      </ul>
    </div>

    <div class="error-section" *ngIf="hasMissingData">
      <button type="button" class="section-header" (click)="toggleSection('missingData')">
        <h4>{{ 'pages.stock.bulkUpload.results.missingDataSection' | translate }} ({{ getTotalMissingDataCount() }}) 
          <span class="toggle-icon">{{ expandedSections.missingData ? '▼' : '▶' }}</span>
        </h4>
      </button>
      <div class="section-content" *ngIf="expandedSections.missingData">
        <div class="error-item" *ngFor="let error of getTruncatedMissingData()">
          <p><strong>{{ 'pages.stock.bulkUpload.results.row' | translate }} {{ error.rowNumber }}:</strong> {{ getMissingFieldsText(error.missingFields) }}</p>
          <div class="missing-fields">
            <div *ngFor="let field of error.missingFields" class="field-value">
              <strong>{{ field }}:</strong> {{ getFieldValue(error.fieldValues, field) }}
            </div>
          </div>
          <hr>
        </div>
        <div class="truncation-notice" *ngIf="isMissingDataTruncated()">
          <p><em>{{ 'pages.stock.bulkUpload.results.truncationNotice' | translate: {showing: maxDisplayItems, total: getTotalMissingDataCount()} }}</em></p>
        </div>
      </div>
    </div>
    <div class="error-section" *ngIf="hasDuplicates">
      <button type="button" class="section-header" (click)="toggleSection('duplicates')">
        <h4>{{ 'pages.stock.bulkUpload.results.duplicatesSection' | translate }} ({{ getTotalDuplicatesCount() }}) 
          <span class="toggle-icon">{{ expandedSections.duplicates ? '▼' : '▶' }}</span>
        </h4>
      </button>
      <div class="section-content" *ngIf="expandedSections.duplicates">
        <div class="error-item" *ngFor="let duplicate of getTruncatedDuplicates()">
          <p><strong>{{ 'pages.stock.bulkUpload.results.row' | translate }} {{ duplicate.rowNumber }}:</strong> {{ 'pages.stock.bulkUpload.results.code' | translate }} {{ duplicate.code }}</p>
          <p class="error-message">{{ duplicate.message }}</p>
          <p class="product-description" *ngIf="duplicate.productDescription">
            <em>{{ duplicate.productDescription }}</em>
        </p>
          <hr>
        </div>
        <div class="truncation-notice" *ngIf="isDuplicatesTruncated()">
          <p><em>{{ 'pages.stock.bulkUpload.results.truncationNotice' | translate: {showing: maxDisplayItems, total: getTotalDuplicatesCount()} }}</em></p>
        </div>
      </div>
    </div>

    <div class="consolidation-section" *ngIf="hasConsolidations">
      <button type="button" class="section-header" (click)="toggleSection('consolidations')">
        <h4>{{ 'pages.stock.bulkUpload.results.consolidationsSection' | translate }} ({{ getTotalConsolidationsCount() }}) 
          <span class="toggle-icon">{{ expandedSections.consolidations ? '▼' : '▶' }}</span>
        </h4>
      </button>
      <div class="section-content" *ngIf="expandedSections.consolidations">
        <div class="error-item" *ngFor="let consolidation of getTruncatedConsolidatedRows()">
          <p><strong>{{ 'pages.stock.bulkUpload.results.row' | translate }} {{ consolidation.rowNumbers.join(', ') }}:</strong> {{ 'pages.stock.bulkUpload.results.code' | translate }} {{ consolidation.code }}</p>
          <p class="consolidation-message">{{ consolidation.message }}</p>
          <p class="product-description" *ngIf="consolidation.productDescription">
            <em>{{ consolidation.productDescription }}</em>
          </p>
          <hr>
        </div>
        <div class="truncation-notice" *ngIf="isConsolidatedRowsTruncated()">
          <p><em>{{ 'pages.stock.bulkUpload.results.truncationNotice' | translate: {showing: maxDisplayItems, total: getConsolidatedRowsCount()} }}</em></p>
        </div>
      </div>
    </div>

    <div class="success-section" *ngIf="response.isSuccess && !hasIssues && !hasPositiveInfo">
      <p><strong>{{ 'pages.stock.bulkUpload.results.successTitle' | translate }}</strong></p>
      <p>{{ 'pages.stock.bulkUpload.results.successMessage' | translate: {count: response.summary?.successful || 0} }}</p>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="exportResults()" *ngIf="hasIssues || hasPositiveInfo" class="btn-primary">
      {{ 'pages.stock.bulkUpload.results.exportResults' | translate }}
    </button>
    <button mat-raised-button (click)="close()" class="btn-secondary">
      {{ 'common.close' | translate }}
    </button>
  </mat-dialog-actions>

</div>
